const convertFacebookTagsToHumanReadable = (text: string) => {
  return text.replaceAll(/@\[(fb_)*(.+?):\d+]/g, '@$2');
};

const removeControlCharacters = (text: string) => {
  return text.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
};

export default {
  convertFacebookTagsToHumanReadable,
  removeControlCharacters,
};
